import "core-js/modules/es6.function.name.js";
//
//
//
//
//
//
import FIBSvg from "./FIBSvg";
export default {
  name: 'FibService',
  components: {
    'fib-svg': FIBSvg
  },
  props: {
    name: {
      type: String
    },
    label: {
      type: String
    },
    isActive: {
      type: Boolean
    }
  },
  computed: {
    themeStyle: function themeStyle() {
      return {
        color: this.$store.getters['theme/theme'].primaryColor
      };
    },
    path: function path() {
      var icon = this.name.toLowerCase();
      return "statics/icons/service/".concat(icon, ".svg");
    }
  }
};